<script>
	export let id;
	export let slideProgress;
	export let kicker;
	export let headline;
	export let teaser;
</script>

<div class="content">
	<div class="kicker">{kicker}</div>
	<h1 class="headline">{headline}</h1>
	<hr />
	<div class="teaser">{teaser}</div>
	<div class="cooperations">
		Eine Recherche von Tagesspiegel <br>und ZDF Magazin Royale
	</div>
</div>

<style lang="scss">
	.content {
		width: 500px;
		text-align: center;
		z-index: 1;
		display: flex;
		flex-direction: column;
		align-items: center;

		@media (max-width: $breakpoint-mobile) {
				margin: 10px;
		}
	}

	.kicker {
		font-family: $ff-sans;
		font-weight: $medium;
		text-transform: uppercase;
		letter-spacing: 0.06em;
		color: $tsp-red;
	}

	h1 {
		font-style: normal;
		color: #c8c8c8;
		font-weight: $bold;
		// letter-spacing: 0.1em;
		font-weight: 700;
		margin-bottom: 0;

		@media (max-width: $breakpoint-mobile) {
			line-height: 44px;
			font-size: 36px;
		}
	}
	
	.teaser {
		color: #c5c5c5;
		width: 100%;
		max-width: 340px;
	}

	.cooperations {
		margin-top: 20px;
		color: #c5c5c5;
		width: 100%;
		// max-width: 340px;
		font-style: italic;
		font-size: 20px;
	}
	

	// .cooperations {
	// 	display: flex;
	// 	width: 100%;
	// 	margin-top: 10px;
	// 	justify-content: space-evenly;
	// 	align-items: center;


	// 	> img:first-child {
	// 		height: 32px;
	// 	}

	// 	> img:last-child {
	// 		height: 70px;
	// 	}
	// }

	hr {
		width: 50px;
		border-color: #c5c5c5;
		margin-top: 25px;
		margin-bottom: 25px;
	}


	@media (min-width: #{$breakpoint-mobile + 1px}) {
		.content {
			position: absolute;
			right: 14vh;
			top: 24%;
		}

		.kicker {
			font-size: 24px;
		}

		h1 {
			font-size: 49px;
			line-height: 125%;
		}

		.teaser {
			font-size: 20px;
			line-height: 28px;
		}
	}

	@media (max-width: $breakpoint-tablet) {
		h1 {
			font-size: 36px;
		}
	}

	@media (max-width: 820px) {
		.content {
			width: 420px;
		}
	}


	@media (max-width: $breakpoint-mobile) {

		hr {
			margin-top: 12px;
			margin-bottom: 12px;
		}

		.cooperations {
			margin-top: 12px;
		}


		.headline {
			margin-top: 10px;
		}

		.content {
			width: 100%;
		}

		.kicker {
			font-size: 18px;
			margin-top: -10px;
		}

		h1 {
			font-size: 33px;
		}

		.teaser {
			font-size: 20px;
			line-height: 28px;
		}
	}
</style>
